import { IExtendedContext } from '../../../types/extendedContext';
import { enablePromotion } from '../../../../shared/ServicePickerWidget/thunks/promotion/enablePromotion';

export const enablePromotionHandler = (context: IExtendedContext) => () => {
  return context.store.dispatch(enablePromotion());
};
